<template>
  <div class="card-section">
    <div class="text-section-header">taxonomies</div>
    <v-container class="details-panel">
      <!--  -->
      <v-row class="details-panel__row">
        <v-col class="details-panel__col" cols="12" md="4">
          <span class="details-panel__label">Service: </span>
        </v-col>
        <v-col class="details-panel__col" cols="12" md="4">
          <v-chip
            class="mr-1 my-1"
            v-for="termData in workTypeTermsDatas"
            :key="termData.term_id"
            small
            @click="handleChipClick(termData)"
            >{{ htmlDecode(termData.name) }}</v-chip
          >
        </v-col>
      </v-row>
      <!--  -->
      <v-row class="details-panel__row">
        <v-col class="details-panel__col" cols="12" md="4">
          <span class="details-panel__label">Client Industry: </span>
        </v-col>
        <v-col class="details-panel__col" cols="12" md="4">
          <v-chip
            class="mr-1 my-1"
            v-for="termData in industriesTermsDatas"
            :key="termData.term_id"
            small
            @click="handleChipClick(termData)"
            >{{ htmlDecode(termData.name) }}</v-chip
          >
        </v-col>
      </v-row>
      <!--  -->
      <v-row class="details-panel__row">
        <v-col class="details-panel__col" cols="12" md="4">
          <span class="details-panel__label">Subject: </span>
        </v-col>

        <v-col class="details-panel__col" cols="12" md="4">
          <v-chip
            class="mr-1 my-1"
            v-for="termData in subjectMatterTermsDatas"
            :key="termData.term_id"
            small
            @click="handleChipClick(termData)"
            >{{ htmlDecode(termData.name) }}</v-chip
          >
        </v-col>
      </v-row>
      <!--  -->
      <v-row class="details-panel__row">
        <v-col class="details-panel__col" cols="12" md="4">
          <span class="details-panel__label">Tech Stack: </span>
        </v-col>

        <v-col class="details-panel__col" cols="12" md="4">
          <v-chip
            class="mr-1 my-1"
            v-for="termData in technologyTermsDatas"
            :key="termData.term_id"
            small
            @click="handleChipClick(termData)"
            >{{ htmlDecode(termData.name) }}</v-chip
          >
        </v-col>
      </v-row>
      <!--  -->
      <v-row class="details-panel__row">
        <v-col class="details-panel__col" cols="12" md="4">
          <span class="details-panel__label">Tags: </span>
        </v-col>

        <v-col class="details-panel__col" cols="12" md="4">
          <v-chip
            class="mr-1 my-1"
            v-for="termData in tagsTermsDatas"
            :key="termData.term_id"
            small
            @click="handleChipClick(termData)"
            >{{ htmlDecode(termData.name) }}</v-chip
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// vuex
import { mapGetters, mapActions } from "vuex";
// library
// internal
import { resetTaxonomyFilters } from "@/utils/miscUtils";
// components
export default {
  name: "TaxonomyPanel",
  props: {
    data: {
      required: true,
      type: Object
    }
  },
  methods: {
    ...mapActions(["setProjectTermFilters"]),
    htmlDecode(input) {
      var doc = new DOMParser().parseFromString(input, "text/html");
      return doc.documentElement.textContent;
    },
    handleChipClick(termData) {
      const newState = resetTaxonomyFilters({
        currentState: this.projectTermFilters
      });

      this.setProjectTermFilters(newState);
      this.$router.push(`/?${termData.taxonomy}=${termData.term_id}`);
    }
  },
  computed: {
    ...mapGetters(["projectTermFilters"]),
    workTypeTermsDatas() {
      return this.data.services;
    },
    subjectMatterTermsDatas() {
      return this.data.subject_matter;
    },
    industriesTermsDatas() {
      return this.data.industries;
    },
    technologyTermsDatas() {
      return this.data.technologies;
    },
    tagsTermsDatas() {
      return this.data.post_tags;
    }
  }
};
</script>

<style lang="scss" scoped>
.details-panel {
  padding: 0px;
  &__row {
    min-height: 30px;
  }

  &__col {
    padding: 8px 0px;
  }

  &__label {
    font-weight: 600;
  }
}
</style>
